<template>
  <div class="case-share-detail">
     <div class="is-weiXin-tip hidden" :class="{'show':is_weixn()}">
          <img class="tip-open" src="@/assets/case-share-detail/what_tip.png" alt="">
      </div>
      <div class="top-bc">
        <img src="@/assets/case-share-detail/topBc.png" alt="" srcset="" class="bc">
      </div>
      <div class="box info">
        <!-- detail.caseGrade 1优质 2精准 其他不显示-->
        <img :src="require(`@/assets/case-share-detail/tag${detail.caseGrade}.png`)" alt="" srcset="" class="tag" v-if="[1,2].includes(detail.caseGrade)">
        <div class="line" v-for="(item,index) in detailArr" :key="index+'detail'" v-show="!isNull(detail[item.key])">
          <p class="title">{{item.title}}</p>
          <p class="value">{{item.arr ? caseDetailFilter(item.arr, detail[item.key]) : detail[item.key]}}</p>
        </div>
      </div>
      <div class="box info question" v-if="caseSourceV2ProblemList.length">
        <h3>平台跟进信息</h3>
        <div class="content">
           <div class="line" v-for="(item,index) in caseSourceV2ProblemList" :key="index+'question'">
            <p class="que">{{item.problemInfo}}</p>
            <p class="ans">{{filterAnswer(item,index)}}</p>
          </div>
        </div>
      </div>
      <div class="box progress">
        <p class="title">服务流程</p>
        <div class="progress-content">
          <div class="item" v-for="item,index in progressArr" :key="index+'progress'">
            <div class="one">
              <p class="circle">{{index+1}}</p>
              <p class="desc">{{item}}
                <!-- <span class="tag" v-show="index===1">个人独享</span> -->
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <p class="btn" @click="openApp">立即前往APP</p>
        <p class="desc">您还没安装法临律师端APP？请点击 <span @click="buttonDownload">立即下载</span></p>
      </div>
  </div>
</template>

<script>
import { getCaseShareDetail } from '@/api/case-share-detail'
import { buriedChannelPoint } from '@/api/common'
// import { buriedChannelPoint,buriedPoint } from '@/api/common'
import { dataDictionary,getCommonClientConfig } from "@a";
import { isNull } from '@/libs/basics-tools'
export default {
  name: "caseShareDetail",
  data() {
    return {
			detailArr: [
        {title:'案件类型',key:'typeLabel'},
        {title:'案件城市',key:'regionName'},
        {title:'案件诉求',key:'appealType',arr:[]},
        {title:'案件来源',key:'regionName'},
        {title:'用户需求',key:'info'},
        {title:'涉案金额',key:'amountGrade',arr:[]},
      ],
      detail: {},
      caseSourceV2ResultList:[],
      caseSourceV2ProblemList:[],
      progressArr: ['锁定案源开始跟进','跟进中','结束跟进标记结果'],
      downloadUrls: {}//下载地址
    };
  },
  mounted(){
    // buriedPoint({code: 'H5PAGE'});
    buriedChannelPoint({code:'LAWYER_GUIDE_CASE_SHARE_PAGE',type: 2, behavior: 'VI'});
    this.getApk();
  },
  components: {
    
  },
	watch: {
    $route: {
      handler(){
        this.getFilterData(this.getCaseShareDetailRes)
      },
      immediate: true
    }
	},
  methods: {
    isNull,
    /**获取案源详情信息 */
    getCaseShareDetailRes(){
      getCaseShareDetail({id: this.$route.query?.caseId}).then((res)=>{
        this.detail = res.data
        this.caseSourceV2ProblemList = res.data.caseSourceV2ProblemList || []
        this.caseSourceV2ResultList = res.data.caseSourceV2ResultList || []
        console.log('获取案源详情信息:', res.data)
      })
    },
    // 处理详情字段转换
    caseDetailFilter(arr, val){
      const i = arr.find((item) => item.value === val)
      return i ? i.label : ''
    },
    /**获取字典数据 */
    getFilterData(callBack){
      let groupCodeArr = ['APPEAL_TYPE','AMOUNT_GRADE']
      let arrIndex = [2, 5]
      let resData = groupCodeArr.map((item,index)=>{
         dataDictionary({ groupCode: item }).then(({ data }) => {
          data.forEach((item) => {
            item.value = Number(item.value)
          })
          this.detailArr[arrIndex[index]].arr = data
        })
      })
      Promise.all(resData).then(res=>{
        callBack(res)
      })
    },
    /** 将后端返回来的答案转换成中文 */
    filterAnswer(dataItem,index) {
      const resultDetail = JSON.parse(dataItem?.resultDetail)
      const resultValue = Number(this.caseSourceV2ResultList[index]?.resultValue)
      return (
        resultDetail?.find((item) => item.answerValue === resultValue)
          ?.answerLabel || resultValue / 100
      )
    },
    /*判断是否微信*/
    is_weixn () {
      var ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    },
     /*按钮点击唤醒app*/
    openApp(){
        console.log(111111111)
        // buriedChannelPoint({code:'LAW_PAGE_GO_TO_APP_PAGE',type: 2, behavior: 'CK'})
        buriedChannelPoint({code:'LAWYER_GUIDE_CASE_SHARE_GO_APP_CLICK',type: 2, behavior: 'CK'})
        // /*唤醒app*/+window.location.search
        // const {search} = this.$route.query
        const {caseId,isExclusive} = this.$route.query
        if(this.isIOSClient()){
            // window.location.href = 'Lawyer://?'+search;
            window.location.href = `Lawyer://?caseId=${caseId}&isExclusive=${isExclusive}&path=share_caseDetail`;
        }else{
            window.location.href = `yoclawyer://yoclawyer/open?caseId=${caseId}&isExclusive=${isExclusive}&path=share_caseDetail`;
        }
    },
    /*按钮点击下载*/
    buttonDownload () {
        // buriedPoint({code: 'DOWNLOAD',extra:{appType:1}})
        // buriedChannelPoint({code: 'LAW_PAGE_DOWN_APP_PAGE',type: 2, behavior: 'CK'})
        buriedChannelPoint({code: 'LAWYER_GUIDE_CASE_SHARE_DOWNLOAD_CLICK',type: 2, behavior: 'CK'})
        this.getApk().then( (value)=> {
            if(this.isIOSClient()){
                window.location.href = value.downloadGfUrlIos;
            }else{
                /*先喚醒安卓应用市场*/
                window.location.href = value.androidGfAppstoreUrl;
                /*防止安卓没有上架到应用市场*/
                setTimeout(function (){
                    window.location.href = value.downloadGfUrlApk;
                },500)
            }
        });
    },
     /*判断是否ios*/
    isIOSClient () {
        return this.judgeClient() === 'IOS';
    },
    /*获取操作系统*/
    judgeClient () {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //判断是否是 android终端
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 ios终端
        if (isAndroid === true) {
            return 'Android';
        } else if (isIOS === true) {
            return 'IOS';
        } else {
            return 'Android';
        }
    },
    /*获取下载地址*/
    getApk() {
      if (this.$basicsTools.isObjNull(this.downloadUrls)) {
        return getCommonClientConfig().then( (value) =>{
          this.downloadUrls = value.data;
          return  this.downloadUrls
        })
      }
      return Promise.resolve(this.downloadUrls)
    },
  },
};
</script>

<style lang="scss" scoped>
.case-share-detail{
  background: #F5F5F7;
  padding-top: 40%;
  box-sizing: border-box;
  padding-bottom: 100px;
  .is-weiXin-tip{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.5);
      z-index: 20;
      text-align: right;
      .tip-open{
          width: 5.08rem;
          height: 3.52rem;
          position: fixed;
          z-index: 5;
          top: 0;
          right:0.12rem;
      }
  }
  .hidden{
    display: none;
  }
  .show{
      display: block;
  }
  .top-bc{
    width: 375px;
    height:325px;
    position: absolute;
    top: -5%;
    .bc{
      width: 100%;
    }
  }
  .box{
    width: 351px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 16px;
    margin: 0 auto;
    margin-bottom: 12px;
  }
  .info{
    position: relative;
    .tag{
      position: absolute;
      width: 72px;
      height: 24px;
      right: 0;
      top: 16px;
    }
    .line{
      display: flex;
      font-size: 14px;
      margin-bottom: 16px;
      &:last-child{
        margin-bottom: 0;
      }
      .title{
        color: #6B6B6F;
        width: 80px;
        word-wrap: break-word;
        word-break: break-all;
      }
      .value{
        color: #46474B;
        flex: 1;
        word-wrap: break-word;
        word-break: break-all;
      }
    }
  }
  .question{
    h3{
      color: #111;
      font-size: 16px;
      margin-bottom: 12px;
    }
    .content{
      width: 319px;
      background: #F5F6FF;
      box-sizing: border-box;
      padding: 14px 8px 14px 12px;
      .line{
        display: flex;
        justify-content: space-between;
        margin-bottom: 28px;
        &:last-child{
          margin-bottom: 0;
        }
        .que{
          color: #666;
        }
        .ans{
          color: #333333;
        }
      }
    }
  }
  .progress{
    font-size: 14px;
    .title{
      color: #6B6B6F;
      margin-bottom: 16px;
    }
    &-content{
      display: flex;
      .item{
        flex: 1;
        font-size: 12px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        &:first-child{
          justify-content: flex-start;
           &::after{
            content: '';
            width: 130px;
          }
        }
        &:last-child{
          justify-content: flex-end;
        }
        .one{
          width: 55px;
          height: 62px;
          display: flex;
          flex-direction: column;
          align-items: center;
            .circle{
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #CCCCCC;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            margin-bottom: 8px;
            z-index: 1;
          }
          .desc{
            color: #333;
            text-align: center;
            .tag{
              background: rgba(53, 178, 142, 0.15);
              border-radius: 8px;
              color: #35B28E;
              margin-top: 2px;
              display: inline-block;
              width: 64px;
              height: 16px;
              text-align: center;
              line-height: 16px;
              font-size: 12px;
            }
          }
        }
        &:last-child{
          &::after{
            display: none;
          }
        }
        &::after{
          content: '';
          width: 145px;
          height: 2px;
          background: #ccc;
          position: absolute;
          left: 29px;
          top: 10px;
        }
      
      }
    }
  }
  .btn-box{
    border-radius: 16px 16px 0 0;
    background: #fff;
    padding: 12px 16px 32px 12px;
    position: fixed;
    bottom: 0;
    height: 100px;
    box-sizing: border-box;
    z-index: 3;
    .btn{
      color: #fff;
      font-size: 16px;
      width: 343px;
      height: 44px;
      background: #4A539E;
      line-height: 44px;
      text-align: center;
      margin-bottom: 12px;
      border-radius: 49px;
    }
    .desc{
      text-align: center;
      font-size: 14px;
      color: #333;
      span{
       text-decoration: underline;
        color: #4A539E;
      }
    }
  }
}
</style>
